const resource = {
  translation: {
    connectWallet: '连接钱包',
    title: '可以随时兑换BiFi代币和GBiFi代币',
    form: {
      amount: {
        title: '{{symbol}}数量',
        balance: '钱包余额',
        placeholder: '{{amount}} {{symbol}}以上可进行兑换'
      },
      approve: '允许代币',
      registerToken: '登记代币',
      swap: '兑换',
      error: {
        allowance: '⚠️ 代币付费额度不足。 请重新允许代币，在Meta Mask权限编辑中提高支出限额。'
      },
      initializing: '加载中...'
    },
    description: ''
  }
};

export default resource;
